import { useState } from 'react';
import {
  Menu,
  MenuItem,
  CircularProgress,
  Box,
  styled,
  ButtonOwnProps,
} from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';
import Button from 'components/Button';

const LoadingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  padding: theme.spacing(1, 0),
}));

export type DropdownAction = {
  label: string;
  onClick: () => void;
  disabled?: boolean;
};

type Props = {
  title: string;
  loading: boolean;
  actions: Array<DropdownAction>;
  menuId?: string;
  size?: ButtonOwnProps['size'];
  dialog?: React.ReactNode;
};

const DropdownMenu: React.FC<Props> = ({
  title,
  loading,
  actions,
  menuId = 'dropdown-menu',
  size = 'medium',
  dialog,
}) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <Button
        aria-controls={menuId}
        aria-haspopup="true"
        color="primary"
        variant="contained"
        size={size}
        endIcon={<ArrowDropDown />}
        onClick={(event) => setMenuAnchorEl(event.currentTarget)}
        loading={loading}
      >
        {title}
      </Button>
      <Menu
        id={menuId}
        anchorEl={menuAnchorEl}
        keepMounted
        open={Boolean(menuAnchorEl)}
        onClose={() => setMenuAnchorEl(null)}
      >
        {loading && (
          <MenuItem disabled>
            <LoadingContainer>
              <CircularProgress size={20} />
            </LoadingContainer>
          </MenuItem>
        )}
        {actions.map(({ label, onClick, disabled }, index) => (
          <MenuItem
            key={`dropdown-action-${index}`}
            onClick={() => {
              onClick();
              setMenuAnchorEl(null);
            }}
            disabled={disabled || loading}
          >
            {label}
          </MenuItem>
        ))}
      </Menu>
      {dialog}
    </>
  );
};

export default DropdownMenu;
